const DEFAULT_CARD_LIST = [
  {
    rank: 1,
    icon: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=025",
    code: "BTTOLD",
    name: "BitTorent [OLD]",
    status: "",
    "24h": 1.19,
  },
  {
    rank: 3,
    icon: "https://app.badger.com/assets/icons/badger_head.svg",
    code: "SHIB",
    status: "",

    name: "Shiba Inu",
    "24h": 2.01,
  },
  {
    rank: 4,
    icon: "https://cryptologos.cc/logos/xrp-xrp-logo.svg?v=025",
    code: "SLP",
    status: "",

    name: "Smooth Love Potion",
    "24h": 1.56,
  },
];

export const cardConstants = {
  type: {
    trending: "trending",
    gainers: "gainers",
    recent: "recent",
  },
  title: {
    trending: "Trending",
    gainers: "Biggest gainers",
    recent: "Recently added",
  },
  description: {
    trending: "The top trending cryptocurrencies that people are searching for on Caleb & Brown.",
    gainers: "The top cryptocurrency coins which have gained the most value over a 24h period.",
    recent: "New cryptocurrencies added to Caleb & Brown.",
  },
  defaultCardList: DEFAULT_CARD_LIST,
  dataLimit: 3,
  linkText: "See more",
  noListData: "No list data",
  href: "/markets",
};
